/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is an area chart different from a line chart?`)
};

const es_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué se diferencia un gráfico de área de uno de líneas?`)
};

const de_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie unterscheidet sich ein Flächendiagramm von einem Liniendiagramm?`)
};

const nl_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe verschilt een vlakdiagram van een lijndiagram?`)
};

const fr_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En quoi un graphique en aires diffère-t-il d'un graphique en courbes ?`)
};

const it_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In cosa differisce un grafico ad area da un grafico a linee?`)
};

const pt_br2_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a diferença entre um gráfico de área e um gráfico de linhas?`)
};

const pt_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que difere um gráfico de área de um gráfico de linhas?`)
};

const ja_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エリアチャートは折れ線グラフとどう違いますか？`)
};

const zh_area_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面积图与折线图有什么不同？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_faq_q1", locale)
	if (locale === "en") return en_area_faq_q1(inputs)
	if (locale === "es") return es_area_faq_q1(inputs)
	if (locale === "de") return de_area_faq_q1(inputs)
	if (locale === "nl") return nl_area_faq_q1(inputs)
	if (locale === "fr") return fr_area_faq_q1(inputs)
	if (locale === "it") return it_area_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_area_faq_q1(inputs)
	if (locale === "pt") return pt_area_faq_q1(inputs)
	if (locale === "ja") return ja_area_faq_q1(inputs)
	return zh_area_faq_q1(inputs)
};